View = require 'app/scripts/views/internal/view'

module.exports = class WarningBannerView extends View
  className: 'header-banner mod-warning'
